import { PropsWithChildren } from 'react';
import { HelmetProps, Helmet as ReactHelmet } from 'react-helmet-async';

const Helmet = (props: PropsWithChildren<HelmetProps>) => {
    return <ReactHelmet {...props} />;
};

export default Helmet;
